import { render, staticRenderFns } from "./AddProductAttributesDialog.vue?vue&type=template&id=8a0d226c"
import script from "./AddProductAttributesDialog.ts?vue&type=script&lang=ts&external"
export * from "./AddProductAttributesDialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports